import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import * as apiMethods from "../res/apiMethods.js";
import Tooltip from "@mui/material/Tooltip";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useFormik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NumericFormat } from 'react-number-format';
import * as yup from "yup";
import Swal from "sweetalert2";
import AccessDenied from "./accessDenied";
import ReactDatePicker from "react-datepicker";
import TextField from "@mui/material/TextField";
import { registerLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';
import InputAdornment from "@mui/material/InputAdornment";

// ─── Iconos MUI ───
import BadgeIcon from '@mui/icons-material/Badge';
import PhoneIcon from '@mui/icons-material/Phone';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TodayIcon from '@mui/icons-material/Today';
import DescriptionIcon from '@mui/icons-material/Description';

registerLocale('es', es);

const parseDate = (date) => {
  if (!date) return null;
  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

// ─── Estilo reutilizable para inputs dentro de glass-panel ───
const inputStyle = { background: 'rgba(255, 255, 255, 0.65)', borderRadius: '10px' };

const Clients = () => {
  const [props, setProps] = useState({
    exists: false,
    clientCredits: [],
    user: "",
    puedeEliminar: false, // ← NUEVO
  });

// ─── Data fetching: lógica original intacta ───
useEffect(() => {
  (async () => {
    if (getLastItem(window.location.href) !== "clients") {
      Swal.fire({ title: "Cargando", allowOutsideClick: false });
      Swal.showLoading();
      
      try {
        // UNA SOLA petición en lugar de DOS
        const response = await axios.get(
          apiMethods.GET_CLIENTE_COMPLETO + getLastItem(window.location.href)
        );

        if (response.data.code === 0) {
          formik.resetForm({ values: response.data.cliente });
          setState({ 
            clientCredits: response.data.creditos, 
            exists: true,
            puedeEliminar: response.data.puedeEliminar 
          });
        } else {
          toast.error(response.data.message || 'Error al cargar cliente');
        }
      } catch (error) {
        console.error('Error cargando cliente:', error);
        toast.error('Error al cargar los datos del cliente');
      }
      
      Swal.close();
    }
    
    setState({
      user: JSON.parse(
        atob(window.sessionStorage.getItem("localToken").split(".")[1])
      ),
    });
  })();
}, []);

  // ─── Validación: lógica original intacta ───
  const validationSchema = yup.object().shape({
    telefono: yup
      .string()
      .min(11, "El teléfono debe ser por lo menos de 7 digitos")
      .max(14, "El teléfono debe ser de máximo 10 digitos"),
    email: yup.string().email(),
    birthDate: yup.date(),
  });

  // ─── Formik: lógica original intacta ───
  const formik = useFormik({
    initialValues: {
      tipoDocumento: "",
      documento: "",
      nombre: "",
      telefono: "",
      direccion: "",
      email: "",
      birthDate: null,
      notas: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submitHandler(values);
    },
  });

  const onError = (e) => {
    e.preventDefault();
    
    for (let error in formik.errors) {
      toast.error(formik.errors[error]);
    }
  };

  const setState = (value) => {
    setProps((prevState) => ({ ...prevState, ...value }));
  };

  const getLastItem = (thePath) =>
    thePath.substring(thePath.lastIndexOf("/") + 1);

  // ─── Crear crédito: lógica original intacta ───
  const createCredit = () => {
    axios
      .get(apiMethods.GET_CLIENTE_DOCUMENTO + getLastItem(window.location.href))
      .then((response) => {
        var auxClient = [];
        auxClient.push(response.data.client);
        window.sessionStorage.setItem(
          "clientStored",
          getLastItem(window.location.href)
        );
        window.location.href = "/credits";
      })
      .catch((error) => {
        
      });
  };

  // ─── Eliminar cliente: lógica original intacta ───
  const removeClient = async () => {
    // Validación previa (opcional, ya está en backend)
    if (!props.puedeEliminar) {
      toast.error("No se puede eliminar el cliente porque tiene créditos");
      return;
    }

    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: "Esta acción no se puede deshacer",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({ title: "Eliminando...", allowOutsideClick: false });
          Swal.showLoading();

          const actUsrToken = window.sessionStorage.getItem("localToken");
          
          // UNA SOLA petición en lugar de 6-7
          const response = await axios.post(
            apiMethods.DELETE_CLIENTE_COMPLETO + getLastItem(window.location.href),
            null,
            {
              headers: {
                Authorization: actUsrToken,
              },
            }
          );

          Swal.close();

          if (response.data.code === 0) {
            toast.success('Cliente eliminado exitosamente');
            setTimeout(() => {
              window.location.href = "/home";
            }, 1500);
          } else {
            toast.error(response.data.message || 'Error al eliminar cliente');
          }
        }
      });
    } catch (error) {
      Swal.close();
      console.error('Error eliminando cliente:', error);
      toast.error("Error al eliminar el cliente");
    }
  };

  // ─── Submit handler: lógica original intacta ───
  const submitHandler = async (e) => {
  e.preventDefault();
  
  const actUsrToken = window.sessionStorage.getItem("localToken");

  if (props.exists) {
    // ========================================
    // ACTUALIZAR CLIENTE EXISTENTE (mantiene endpoint actual)
    // ========================================
    try {
      Swal.fire({ title: "Actualizando...", allowOutsideClick: false });
      Swal.showLoading();

      const response = await axios.patch(
        apiMethods.PATCH_CLIENTE_DOCUMENTO + getLastItem(window.location.href),
        formik.values,
        {
          headers: {
            Authorization: actUsrToken,
          },
        }
      );

      Swal.close();

      if (response.data.code === 0 || response.status === 200) {
        toast.success('Cliente actualizado exitosamente');
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error('Error al actualizar el cliente');
      }
    } catch (error) {
      Swal.close();
      console.error('Error actualizando:', error);
      toast.error("Error al actualizar el cliente");
    }
  } else {
    // ========================================
    // CREAR NUEVO CLIENTE (usa endpoint completo)
    // ========================================
    try {
      Swal.fire({ title: "Creando cliente...", allowOutsideClick: false });
      Swal.showLoading();

      // UNA SOLA petición en lugar de 5
      const response = await axios.post(
        apiMethods.CREATE_CLIENTE_COMPLETO,
        formik.values,
        {
          headers: {
            Authorization: actUsrToken,
          },
        }
      );

      Swal.close();

      if (response.data.code === 0) {
        toast.success('Cliente registrado con éxito');
        setTimeout(() => {
          window.location.href = `/clients/${formik.values.documento}`;
        }, 1500);
      } else if (response.data.code === 409) {
        toast.error('El documento ya se encuentra registrado');
      } else {
        toast.error(response.data.message || 'Error al crear el cliente');
      }
    } catch (error) {
      Swal.close();
      console.error('Error creando cliente:', error);
      toast.error("Error al crear el cliente");
    }
  }
};

  // ─── DatePicker custom trigger: lógica original intacta ───
  const DatePickerState = ({ onClick }) => (
    <Button
    className="react-datepicker-ignore-onclickoutside"
    onClick={onClick}
    id="datePicker"
  >
    <TodayIcon style={{ fontSize: 24, color: '#cb1016' }} />
  </Button>
  );

  // ─── DataGrid: botón "Abrir" rediseñado ───
  const renderDetailsButton = (params) => {
    return (
      <button
        className="btn-mobilia-outline"
        style={{ fontSize: '0.74rem', padding: '0.28rem 0.65rem' }}
        onClick={() => {
          const creditId = params.row.id; 
          window.sessionStorage.setItem("localDocument", creditId);
          window.location.href = `/credits/${creditId}`;
        }}
      >
        Abrir <ArrowForwardIcon style={{ fontSize: '0.8rem' }} />
      </button>
    );
  };

  const creditsColumns = [
    { field: "financialCode", headerName: "Documento", width: 250, valueGetter: (value, row) => value || row.id },
    { field: "vlrCapital", headerName: "Capital", width: 250 },
    { field: "plazo", headerName: "Plazo", width: 250 },
    {
      field: "accion",
      headerName: "Acción",
      width: 150,
      renderCell: renderDetailsButton,
    },
  ];

  // ─── Acceso denegado si no hay token ───
  if (!window.sessionStorage.getItem("localToken")) {
    return <AccessDenied />;
  }

  return (
    <>
      <ToastContainer />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', maxWidth: '1080px', margin: '0 auto' }}>

          {/* ─── Header con título dinámico + botones de acción ─── */}
          <div className="section-header">
            <div className="title-group">
              <h1>{props.exists ? `Ficha de Cliente: ${formik.values.nombre || ''}` : 'Registro de Nuevo Titular'}</h1>
              <p>Gestión de información básica, contacto y perfil financiero del deudor</p>
            </div>
            {props.user?.roleId == 1 && (
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                <button
                  type="button"
                  className="btn-mobilia-primary"
                  disabled={!formik.dirty}
                  onClick={submitHandler}
                >
                  <SaveIcon style={{ fontSize: '1rem' }} /> Guardar
                </button>
                {props.exists && (
                  <>
                    <button
                      type="button"
                      className="btn-mobilia-secondary"
                      onClick={createCredit}
                    >
                      <AddCircleOutlineIcon style={{ fontSize: '1rem' }} /> Crear Crédito
                    </button>
                    <Tooltip 
                      title={!props.puedeEliminar ? "No se puede eliminar porque tiene créditos asociados" : ""}
                      arrow
                      slotProps={{
                        tooltip: {
                          sx: { fontSize: 13, padding: '8px 14px', background: '#dc2626' }
                        }
                      }}
                    >
                      <span>
                        <button
                          type="button"
                          className="btn-mobilia-outline"
                          style={{ color: props.puedeEliminar ? '#dc2626' : '#94a3b8', borderColor: props.puedeEliminar ? '#dc2626' : '#e2e8f0' }}
                          onClick={removeClient}
                          disabled={!props.puedeEliminar}
                        >
                          <DeleteOutlineIcon style={{ fontSize: '1rem' }} /> Eliminar
                        </button>
                      </span>
                    </Tooltip>
                  </>
                )}
              </div>
            )}
          </div>

          {/* ─── Formulario principal ─── */}
          <form
            onSubmit={(e) => {
              formik.isValid ? submitHandler(e) : onError(e);
            }}
            style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
          >

            {/* ─── Bloque 1: Identificación y Datos Básicos ─── */}
            <div className="glass-panel" style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.35rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', borderBottom: '1px solid rgba(15, 23, 42, 0.06)', paddingBottom: '0.85rem' }}>
                <BadgeIcon style={{ color: '#cb1016', fontSize: '1.25rem' }} />
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0, color: '#090d16' }}>
                  Identificación y Datos Básicos
                </h3>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 2fr', gap: '1.25rem' }}>
                <TextField
                  select
                  label="Tipo Doc. *"
                  size="small"
                  disabled={props.exists || props.user?.roleId !== 1}
                  id="tipoDocumento"
                  name="tipoDocumento"
                  value={formik.values.tipoDocumento}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                >
                  <MenuItem value="C.C.">Cédula de Ciudadanía</MenuItem>
                  <MenuItem value="C.E.">Cédula de Extranjería</MenuItem>
                  <MenuItem value="N.I.T.">N.I.T.</MenuItem>
                </TextField>

                <TextField
                  required
                  label="Número de Documento"
                  size="small"
                  id="documento"
                  disabled={props.exists || props.user?.roleId !== 1}
                  value={formik.values.documento}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                />

                <TextField
                  required
                  label="Nombre Completo / Razón Social"
                  size="small"
                  id="nombre"
                  disabled={props.user?.roleId == 1 ? false : true}
                  value={formik.values.nombre}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                />
              </div>
            </div>

            {/* ─── Bloque 2: Contacto y Ubicación ─── */}
            <div className="glass-panel" style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.35rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', borderBottom: '1px solid rgba(15, 23, 42, 0.06)', paddingBottom: '0.85rem' }}>
                <PhoneIcon style={{ color: '#cb1016', fontSize: '1.25rem' }} />
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0, color: '#090d16' }}>
                  Ubicación y Canales de Contacto
                </h3>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1.25rem' }}>
                <TextField
                  required
                  type="email"
                  label="Correo Electrónico"
                  size="small"
                  id="email"
                  disabled={props.user?.roleId == 1 ? false : true}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                />

                <NumericFormat 
                  customInput={TextField}
                  label="Teléfono Móvil"
                  size="small"
                  required
                  id="telefono"
                  disabled={props.user?.roleId == 1 ? false : true}
                  format="(###) ###-####"
                  value={formik.values.telefono}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                />

                <TextField
                  required
                  label="Dirección de Correspondencia"
                  size="small"
                  id="direccion"
                  disabled={props.user?.roleId == 1 ? false : true}
                  value={formik.values.direccion}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                />
              </div>
            </div>

            {/* ─── Bloque 3: Información Adicional ─── */}
            <div className="glass-panel" style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.35rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', borderBottom: '1px solid rgba(15, 23, 42, 0.06)', paddingBottom: '0.85rem' }}>
                <EventAvailableIcon style={{ color: '#059669', fontSize: '1.25rem' }} />
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0, color: '#090d16' }}>
                  Información Complementaria
                </h3>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
                <TextField
                  label="Fecha de Nacimiento"
                  size="small"
                  disabled={props.user?.roleId !== 1}
                  value={formik.values.birthDate ? new Date(formik.values.birthDate).toLocaleDateString('es-CO') : ''}
                  InputProps={{
                    readOnly: true,
                    style: inputStyle,
                    endAdornment: (
                      <InputAdornment position="end">
                        <ReactDatePicker
                          locale="es"
                          disabled={props.user?.roleId !== 1}
                          dateFormat="dd/MM/yyyy"
                          id="birthDate"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={parseDate(formik.values.birthDate)}
                          onChange={(value) => formik.setFieldValue("birthDate", value)}
                          customInput={<DatePickerState />}
                        />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Notas / Observaciones"
                  size="small"
                  multiline
                  rows={3}
                  disabled={props.user?.roleId == 1 ? false : true}
                  id="notas"
                  value={formik.values.notas}
                  onChange={formik.handleChange}
                  InputProps={{ style: inputStyle }}
                />
              </div>
            </div>
          </form>

          {/* ─── Tabla de Créditos Asociados (solo en modo detalle) ─── */}
          {props.exists && (
            <div className="glass-panel" style={{ padding: '1.85rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                  <DescriptionIcon style={{ color: '#cb1016', fontSize: '1.25rem' }} />
                  <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: '#090d16' }}>
                    Expedientes de Crédito Asociados ({props.clientCredits.length})
                  </h3>
                </div>
                <span style={{ fontSize: '0.78rem', color: '#64748b' }}>
                  Base de datos sincronizada
                </span>
              </div>

              <div style={{ height: 300, width: "100%" }}>
                <DataGrid
                  rows={props.clientCredits}
                  columns={creditsColumns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10]}
                  disableSelectionOnClick
                  sx={{
                    border: '1px solid #EAECF0',
                    borderRadius: '14px',
                    '& .MuiDataGrid-columnHeaders': {
                      background: '#F9FAFB',
                      borderBottom: '1px solid #EAECF0',
                      fontSize: '0.78rem',
                      fontWeight: 600,
                      color: '#667085',
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em'
                    },
                    '& .MuiDataGrid-cell': {
                      fontSize: '0.85rem',
                      color: '#111111',
                      borderBottom: '1px solid #F2F4F7'
                    },
                    '& .MuiDataGrid-row:hover': {
                      background: '#F9FAFB'
                    }
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </LocalizationProvider>
    </>
  );
};

export default Clients;
